<template>
  <v-card>
    <v-data-table :loading="loading" :headers="headers" :items="dataList" class="table-rounded" disable-sort>
      <!--   TODO:    :options.sync="option"
      :server-items-length="itemLength"
      -->

      <template v-slot:[`item.announcement_button`]="{ item }">
        <div class="d-flex align-center justify-space-around">
          <div>
            <router-link :to="{ name: 'editAnnouncement', params: { id: item.id } }">
              <v-btn color="accent" small>
                {{ $t('general.edit') }}
              </v-btn>
            </router-link>
          </div>
          <div>
            <v-btn color="error" @click="removeAnnouncement(item.id)" small>
              {{ $t('general.delete') }}
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:[`item.jobs_button`]="{ item }">
        <div class="d-flex align-center justify-space-around">
          <div>
            <router-link :to="{ name: 'editJob', params: { id: item.id } }">
              <v-btn color="accent" small>
                {{ $t('general.edit') }}
              </v-btn>
            </router-link>
          </div>
          <div class="">
            <v-btn color="error" @click="removeJob(item.id)" small>
              {{ $t('general.delete') }}
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:[`item.report_button`]="{ item }">
        <div class="d-flex align-center justify-space-around">
          <div>
            <router-link :to="{ name: 'editReport', params: { id: item.id } }">
              <v-btn color="accent" small>
                {{ $t('general.edit') }}
              </v-btn>
            </router-link>
          </div>
          <div>
            <v-btn color="error" @click="removeReport(item.id)" small>
              {{ $t('general.delete') }}
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:[`item.media_coverage_button`]="{ item }">
        <div class="d-flex align-center justify-space-around">
          <div>
            <router-link :to="{ name: 'editMediaCoverage', params: { id: item.id } }">
              <v-btn color="accent" small>
                {{ $t('general.edit') }}
              </v-btn>
            </router-link>
          </div>
          <div>
            <v-btn small color="error" @click="removeMediaCoverage(item.id)">
              {{ $t('general.delete') }}
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:[`item.press_release_button`]="{ item }">
        <div class="d-flex align-center justify-space-around">
          <div>
            <router-link :to="{ name: 'editPressRelease', params: { id: item.id } }">
              <v-btn color="accent" small>
                {{ $t('general.edit') }}
              </v-btn>
            </router-link>
          </div>
          <div>
            <v-btn color="error" @click="removePressRelease(item.id)" small>
              {{ $t('general.delete') }}
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:[`item.presentation_button`]="{ item }">
        <div class="d-flex flex-wrap align-center flex-sm-column flex-md-row flex-lg-row flex-xl-row pa-sm-2">
          <div>
            <router-link :to="{ name: 'editPresentation', params: { id: item.id } }">
              <v-btn color="accent">
                {{ $t('general.edit') }}
              </v-btn>
            </router-link>
          </div>
          <div class="ml-xl-4 ml-lg-4 ml-md-4 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
            <v-btn color="error" @click="removePresentation(item.id)">
              {{ $t('general.delete') }}
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:[`item.analyst_coverage_button`]="{ item }">
        <div class="d-flex flex-wrap align-center flex-sm-column flex-md-row flex-lg-row flex-xl-row pa-sm-2">
          <div>
            <router-link :to="{ name: 'editAnalystCoverage', params: { id: item.id } }">
              <v-btn color="accent">
                {{ $t('general.edit') }}
              </v-btn>
            </router-link>
          </div>
          <div class="ml-xl-4 ml-lg-4 ml-md-4 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
            <v-btn color="error" @click="removeAnalystCoverage(item.id)">
              {{ $t('general.delete') }}
            </v-btn>
          </div>
        </div>
      </template>
      <template v-slot:[`item.investor_notices_button`]="{ item }">
        <div class="d-flex flex-wrap align-center flex-sm-column flex-md-row flex-lg-row flex-xl-row pa-sm-2">
          <div>
            <router-link :to="{ name: 'editInvestorNotices', params: { id: item.id } }">
              <v-btn color="accent">
                {{ $t('general.edit') }}
              </v-btn>
            </router-link>
          </div>
          <div class="ml-xl-4 ml-lg-4 ml-md-4 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
            <v-btn color="error" @click="removeInvestorNotices(item.id)">
              {{ $t('general.delete') }}
            </v-btn>
          </div>
        </div>
      </template>
    </v-data-table>
    <SnackBar :text="snack_bar_text" :snackbar="snack_bar_open" v-on:close="updateSnackBar" />
    <Dialog :dialog.sync="dialog_open" v-on:close="getDialogValue" :text="dialog_text" />
  </v-card>
</template>

<script>
import { globalFunc } from '@/global'
import { mdiEye } from '@mdi/js'
import Dialog from '@/components/Dialog'
import SnackBar from '@/components/SnackBar'
import { postData } from '@/api'

export default {
  name: 'Table',
  props: ['headers', 'dataList', 'loading', 'options', 'itemLength'],
  mixins: [globalFunc],
  components: {
    Dialog,
    SnackBar,
  },
  data: () => ({
    items: [],
    eye_icon: mdiEye,
    option: {},
    list: [],
    dialog_open: false,
    dialog_text: '',
    dialog_type: '',
    item_id: -1,
    snack_bar_text: '',
    snack_bar_open: false,
  }),
  watch: {
    dataList: function(newVal, oldVal) {
      this.list = JSON.parse(JSON.stringify(newVal))
    },
    options: function(newVal, oldVal) {
      Object.assign(this.option, newVal)
    },
  },
  methods: {
    removeAnnouncement(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.announcement') + '?'
      this.dialog_type = 'announcement_data'
      this.item_id = id
      this.dialog_open = true
    },
    removeReport(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.report') + '?'
      this.dialog_type = 'report_data'
      this.item_id = id
      this.dialog_open = true
    },
    removePressRelease(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.press_release') + '?'
      this.dialog_type = 'event_data'
      this.item_id = id
      this.dialog_open = true
    },
    removeMediaCoverage(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.media_coverage') + '?'
      this.dialog_type = 'news_data'
      this.item_id = id
      this.dialog_open = true
    },
    removeJob(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$tc('navigation.jobs', 1) + '?'
      this.dialog_type = 'job_data'
      this.item_id = id
      this.dialog_open = true
    },
    removePresentation(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.presentation') + '?'
      this.dialog_type = 'presentation_data'
      this.item_id = id
      this.dialog_open = true
    },
    removeAnalystCoverage(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.analyst_coverage') + '?'
      this.dialog_type = 'analyst_coverage_data'
      this.item_id = id
      this.dialog_open = true
    },
    removeInvestorNotices(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.investor_notices') + '?'
      this.dialog_type = 'investor_relation_notices_data'
      this.item_id = id
      this.dialog_open = true
    },
    async getDialogValue(action) {
      this.dialog_open = false
      if (action) {
        if (this.dialog_type != '' && this.item_id != -1) {
          try {
            let params = new URLSearchParams()

            params.set(
              'delete_data_by_data_type_and_id',
              JSON.stringify({
                id: this.item_id,
                data_type: this.dialog_type,
              }),
            )

            let remove_data = await postData(params)

            this.snack_bar_open = true
            this.snack_bar_text = this.$t('instruction.remove_success')

            setTimeout(() => {
              location.reload()
            }, 2000)
          } catch (error) {
            globalFunc.log(error)
            this.snack_bar_open = true
            this.snack_bar_text = this.$t('instruction.remove_fail')
          }
        }
      }
    },
    updateSnackBar(status) {
      this.snack_bar_open = status
    },
  },
}
</script>
